import React from 'react';
import * as DatesUtils from '../../utils/dates';
import * as CurrencyUtils from '../../utils/currency';
import { Languages } from '../../config';

const CONFIGURATION = {};

export const allowedActions = {};

export default CONFIGURATION;

export const TableColumns = [
  {
    label: '#',
    id: 'applicant_payment_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'VAT Number',
    id: 'vat_num',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Period',
    id: 'quarter_id',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <React.Fragment>
        {data[rowIndex].quarter} {data[rowIndex].year}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Submission Date',
    id: 'submission_date',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{DatesUtils.formatDate(cellValue)}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Payable amount',
    id: 'total_vat_amount_payable',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        € {CurrencyUtils.formatCurrency(cellValue)}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Paid Amount',
    id: 'amount',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        €{CurrencyUtils.formatCurrency(cellValue)}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Payment Date',
    id: 'payment_date',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{DatesUtils.formatDate(cellValue)}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Is Allocated?',
    id: 'is_allocated',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue ? 'Yes' : 'No'}</React.Fragment>
    ),
    inData: true,
  },
];

interface ITableDefaultFetchValues {
  TABLE_DEFAULT_PAGE: number;
  TABLE_DEFAULT_PAGE_SIZE: number;
  TABLE_DEFAULT_ORDER: 'desc' | 'asc';
  TABLE_DEFAULT_SORT_KEY: string;
}

export const TableDefaultFetchValues: ITableDefaultFetchValues = {
  TABLE_DEFAULT_PAGE: 0,
  TABLE_DEFAULT_PAGE_SIZE: 25,
  TABLE_DEFAULT_ORDER: 'desc',
  TABLE_DEFAULT_SORT_KEY: 'applicant_payment_id',
};

export const Translations = {
  page_title: {
    [Languages.Greek]: 'Payments',
    [Languages.English]: 'Payments',
  },
  table_title: {
    [Languages.Greek]: 'Manage Payments',
    [Languages.English]: 'Manage Payments',
  },
  payment_info: {
    [Languages.Greek]: 'Allocate Payments',
    [Languages.English]: 'Allocate Payments',
  },
  description: {
    [Languages.Greek]:
      'Review your One-Stop-Shop Payments from the list below. You can see all the Payments made so far regarding your VAT Returns for OSS, with information indicating the Amount of the Payment, the Payment Date and whether it has been Processed/Alloceted by the Tax Department or not. For clarifications or questions regarding the OSS Payments please contact the System Administrator.',
    [Languages.English]:
      'Review your One-Stop-Shop Payments from the list below. You can see all the Payments made so far regarding your VAT Returns for OSS, with information indicating the Amount of the Payment, the Payment Date and whether it has been Processed/Alloceted by the Tax Department or not. For clarifications or questions regarding the OSS Payments please contact the System Administrator.',
  },
  vat_number: {
    [Languages.Greek]: 'VAT Number',
    [Languages.English]: 'VAT Number',
  },
  originatingCountry: {
    [Languages.Greek]: 'MSID Country',
    [Languages.English]: 'MSID Country',
  },
  schemeType: {
    [Languages.Greek]: 'Scheme Type',
    [Languages.English]: 'Scheme Type',
  },
  state: {
    [Languages.Greek]: 'State',
    [Languages.English]: 'State',
  },
  search: {
    [Languages.Greek]: 'Search',
    [Languages.English]: 'Search',
  },
  go_to_dashboard: {
    [Languages.Greek]: 'Go to dashboard',
    [Languages.English]: 'Go to dashboard',
  },
  clear: {
    [Languages.Greek]: 'Clear',
    [Languages.English]: 'Clear',
  },
};
